import React, { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { selectStyles } from "../utils/selectStyles";

const MultiSelectWithValidation = ({ data, setFieldValue, productlabels }) => {
  const [labels, setlabels] = useState([]);
  useEffect(() => {
    if (productlabels) {
      const updatedValues = productlabels.map((item) => ({
        id: item.id,
        label: item.label,
        date: item.date ? item.date.split("T")[0] : "",
      }));
      setlabels(updatedValues);
    }
  }, [productlabels]);

  const handleChangeAttr = (options) => {
    const validOptions = options.filter((option) =>
      data.some((item) => item.id === option.value)
    );
    const updatedValues = validOptions.map((option) => {
      const existing = labels.find((item) => item.id === option.value);
      return existing || { id: option.value, label: option.label, date: "" };
    });
    setlabels(updatedValues);
    if (setFieldValue) {
      setFieldValue("productlabels", updatedValues);
    }
  };

  const handleDateChange = (id, date) => {
    const updatedValues = labels.map((item) =>
      item.id === id ? { ...item, date } : item
    );

    setlabels(updatedValues);
    if (setFieldValue) {
      setFieldValue("productlabels", updatedValues);
    }
  };

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  return (
    <div>
      <CreatableSelect
        name="attributes"
        placeholder="Select attributes"
        value={labels.map((item) => ({
          value: item.id,
          label: item.label,
        }))}
        onChange={handleChangeAttr}
        options={data.map((item) => ({
          value: item.id,
          label: item.name,
        }))}
        isMulti
      />
      <div style={{ marginTop: "20px" }}>
        {labels.map((attribute) => (
          <div key={attribute.id} style={{ marginBottom: "15px" }}>
            <label>{attribute.label} - Expiry Date:</label>
            <input
              type="date"
              value={attribute.date || ""}
              min={getTodayDate()}
              onChange={(event) => handleDateChange(attribute.id, event.target.value)}
              style={{ marginLeft: "10px" }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const Sizemultiselect = ({
  sizedata,
  values,
  setFieldValue,
  totalQuantity,
  sizeErrors,
  type,
}) => {
  const [sizeDetails, setSizeDetails] = useState([]);
  const normalizedValues = Array.isArray(values) ? values : [];
  useEffect(() => {
    if (normalizedValues.length > 0 && sizedata.length > 0) {
      const initialDetails = normalizedValues.map((size) => ({
        id: size.size_id || size.id,
        sizeName:
          sizedata.find((data) => data.id === (size.size_id || size.id))?.value ||
          "",
        price: size.price || 0,
        quantity: size.quantity || 0,
      }));
      setSizeDetails(initialDetails);
    }
  }, [values, sizedata]);


  useEffect(() => {
    if (totalQuantity && sizeDetails.length > 0) {
      const quantityPerSize = Math.floor(totalQuantity / sizeDetails.length);
      const remainder = totalQuantity % sizeDetails.length;
      setSizeDetails((prevDetails) =>
        prevDetails.map((detail, index) => ({
          ...detail,
          quantity: index < remainder ? quantityPerSize + 1 : quantityPerSize,
        }))
      );
    }
  }, [totalQuantity]);

  const handleSizeChange = (selectedSizes) => {
    const updatedDetails = selectedSizes.map((size) => {
      const existing = sizeDetails.find((detail) => detail.id === size.id);
      return existing
        ? { ...existing }
        : { id: size.id, sizeName: size.value, price: 0, quantity: 0 };
    });

    setSizeDetails(updatedDetails);
    setFieldValue("sizes", updatedDetails);
  };

  const handleInputChange = (index, field, value) => {
    const updatedDetails = [...sizeDetails];
    updatedDetails[index][field] = Number(value);
    setSizeDetails(updatedDetails);
    setFieldValue(
      "sizes",
      updatedDetails.map(({ sizeName, ...rest }) => rest)
    );
  };


  const filteredOptions =
    type === "catalogue" && Array.isArray(values)
      ? sizedata.filter((size) =>
        values.some((v) => v.size_id === size.id || v.id === size.id)
      )
      : sizedata;


  return (
    <div>
      {sizedata.length > 0 && (
        <div className="form-group">
          <label className="col-form-label ">Select size</label>
          <CreatableSelect
            isMulti
            value={sizeDetails.map((detail) => ({
              id: detail.id,
              value: detail.sizeName,
            }))}
            onChange={handleSizeChange}
            options={type === "catalogue" ? filteredOptions : sizedata}
            getOptionLabel={(option) => option.value}
            getOptionValue={(option) => option.id}
            placeholder="Select size"
             styles={selectStyles}
          />
          {sizeErrors && (
            <small className="text-danger">
              {typeof sizeErrors === "string" ? sizeErrors : ""}
            </small>
          )}
          
           
        </div>
      )}
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {sizeDetails.map((sizeDetail, index) => (
          <div
            key={index}
            style={{ display: "flex", gap: "20px" }}
          >
            <div className="form-group">
              <label>Price: {sizeDetail.sizeName}</label>
              <input
                type="number"
                value={sizeDetail.price}
                onChange={(e) => handleInputChange(index, "price", e.target.value)}
                placeholder="Enter price"
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Quantity: {sizeDetail.sizeName}</label>
              <input
                type="number"
                value={sizeDetail.quantity}
                onChange={(e) => handleInputChange(index, "quantity", e.target.value)}
                placeholder="Enter quantity"
                className="form-control"
              />
              {sizeErrors?.[index]?.quantity && (
                <small className="text-danger">{sizeErrors[index].quantity}</small>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export { Sizemultiselect };
export default MultiSelectWithValidation;
